export default __webpack_public_path__ + "static/media/cosmonautBlue.3846daa6.svg";